
import React from 'react';
import { Tables } from '@/integrations/supabase/types';
import ConfirmationDialog from '@/components/interview/ConfirmationDialog';
import SuggestionsHeader from './SuggestionsHeader';
import SuggestionsList from './SuggestionsList';
import DebugPanel from './DebugPanel';
import { useSuggestionsData } from '@/hooks/interview/useSuggestionsData';
import { useDebugMode } from '@/hooks/interview/useDebugMode';
import { useDeleteSuggestion } from '@/hooks/interview/useDeleteSuggestion';

const SuggestionsTab: React.FC = () => {
  const {
    suggestions,
    setSuggestions,
    isLoading,
    isRefreshing,
    realtimeConnected,
    fetchMethod,
    fetchSuggestions,
    changeFetchMethod,
    handleManualCheck,
    suggestionsPreview
  } = useSuggestionsData();

  const {
    isDebugMode,
    toggleDebugMode,
    handleCreateTestSuggestion,
    handleCreateDirectSuggestion
  } = useDebugMode(fetchSuggestions);

  const {
    deleteConfirmation,
    handleDeleteClick,
    handleConfirmDelete,
    handleCancelDelete
  } = useDeleteSuggestion(fetchSuggestions);

  return (
    <div>
      <SuggestionsHeader 
        isRefreshing={isRefreshing}
        isDebugMode={isDebugMode}
        fetchSuggestions={fetchSuggestions}
        toggleDebugMode={toggleDebugMode}
      />
      
      {isDebugMode && (
        <DebugPanel
          realtimeConnected={realtimeConnected}
          suggestionsCount={suggestions.length}
          isLoading={isLoading}
          fetchMethod={fetchMethod}
          suggestionsPreview={suggestionsPreview}
          changeFetchMethod={changeFetchMethod}
          handleCreateTestSuggestion={handleCreateTestSuggestion}
          handleCreateDirectSuggestion={handleCreateDirectSuggestion}
          handleManualCheck={handleManualCheck}
        />
      )}
      
      <SuggestionsList 
        suggestions={suggestions}
        isLoading={isLoading}
        onDeleteClick={handleDeleteClick}
      />
      
      <ConfirmationDialog
        isOpen={deleteConfirmation.isOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        title="Slett tips"
        description="Er du sikker på at du vil slette dette tipset? Denne handlingen kan ikke angres."
        confirmText="Slett"
        cancelText="Avbryt"
        isDanger={true}
        isLoading={deleteConfirmation.isDeleting}
      />
    </div>
  );
};

export default SuggestionsTab;
